// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c568ab4f","667":"46c8438d"}[chunkId] + ".chunk.js";
};